import { ContactProperty } from 'modules/installation-wizard/classes/contactProperty';
import { AppResponse } from 'modules/core/interfaces/appResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AxiosResponse } from 'axios';
import store from '@/store/index';

export class PropertiesApi {
  public MasterAccountId: string;

  public constructor() {
    this.MasterAccountId = store.state.auth && store.state.auth.user
        ? store.state.auth.user.MasterAccountId
        : null;
  }

  public async getProps(): Promise<ContactProperty[] | undefined> {
    const response: AxiosResponse<
      AppResponse<ContactProperty[]>
    > = await AuthorizedApiClient.get('/account/GetProperties');

    const appResponse: AppResponse<ContactProperty[]> = response.data;
    if (appResponse.IsSuccess) {
      const devices: ContactProperty[] = appResponse.Result ? appResponse.Result : [];
      return devices;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async updateProps(props: ContactProperty[]) {
    this.updateMasterAccountId();
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<
      AppResponse<string>
    > = await AuthorizedApiClient.post('/contact/ConfigureProperties', {
      MasterAccountId,
      ConfigItems: props,
    });

    const appResponse: AppResponse<string> = response.data;
    if (appResponse.IsSuccess) {
      return appResponse.Result;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  private updateMasterAccountId() {
    this.MasterAccountId = store.state.auth && store.state.auth.user
        ? store.state.auth.user.MasterAccountId
        : null;
  }
}

